var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
export var addAnonymousAnalyticsMutation = function (orgId) { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation addUserAnalytics($input: REST!) {\n      addedUserAnalytics(input: $input) @rest(type: \"AnonymousAnalytics\", path: \"/anonymous-analytics?orgId=", "\", method: \"POST\", endpoint: \"command\") {\n        id\n      }\n    }\n  "], ["\n    mutation addUserAnalytics($input: REST!) {\n      addedUserAnalytics(input: $input) @rest(type: \"AnonymousAnalytics\", path: \"/anonymous-analytics?orgId=", "\", method: \"POST\", endpoint: \"command\") {\n        id\n      }\n    }\n  "])), orgId),
}); };
export var addAnonymousAnalyticsVariables = function (input) { return ({
    variables: {
        input: input,
    },
}); };
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/addAnonymousAnalytics.ts
// module id = 684
// module chunks = 81